import { createSelector } from 'reselect'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current/index.js'
import getValueReduxUtil from 'modules/redux/utils/get-value/index.js'
import { USER_KEY } from '@gymaholic/packages'

export const getSubscriptionCanceledAtUserSelect = createSelector(
  getCurrentTrainingUserSelect,
  (user) => getValueReduxUtil(user, USER_KEY.SUBSCRIPTION_CANCELED_AT)
)
